/**
 * @generated SignedSource<<fdbf5cded7e19e7572ca9dc662f84f4c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueNavigator_issueQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_refetchQuery">;
  readonly " $fragmentType": "main_issueNavigator_IssueNavigator_issueQuery";
};
export type main_issueNavigator_IssueNavigator_issueQuery$key = {
  readonly " $data"?: main_issueNavigator_IssueNavigator_issueQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_issueQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueNavigator_issueQuery",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "projectKey",
              "variableName": "projectKey"
            },
            {
              "kind": "Variable",
              "name": "projectKeys",
              "variableName": "projectKeys"
            }
          ],
          "kind": "FragmentSpread",
          "name": "main_issueNavigator_IssueNavigator_refetchQuery"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "ed13d620aae6f77ba895670853153576";

export default node;
